import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Carousel({ title, subtitle, children, filters, testId = "carousel" }) {
    const ref = useRef(null);
    const scroll = (dir) => {
        if (!ref.current) return;
        const amount = ref.current.clientWidth * 0.85;
        ref.current.scrollBy({ left: dir === "next" ? amount : -amount, behavior: "smooth" });
    };
    return (
        <section data-testid={`${testId}-section`} className="relative">
            <div className="mx-auto max-w-[1600px] px-6 lg:px-10 flex items-end justify-between mb-4">
                <div>
                    <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">
                        {title}
                    </h2>
                    {subtitle && <p className="text-sm text-white/50 mt-1">{subtitle}</p>}
                </div>
                <div className="hidden sm:flex gap-2">
                    <button
                        data-testid={`${testId}-prev`}
                        onClick={() => scroll("prev")}
                        className="w-10 h-10 rounded-full backdrop-blur-md bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#FFD400] hover:text-black text-white transition-colors"
                        aria-label="Previous"
                    >
                        <ChevronLeft className="w-5 h-5" />
                    </button>
                    <button
                        data-testid={`${testId}-next`}
                        onClick={() => scroll("next")}
                        className="w-10 h-10 rounded-full backdrop-blur-md bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#FFD400] hover:text-black text-white transition-colors"
                        aria-label="Next"
                    >
                        <ChevronRight className="w-5 h-5" />
                    </button>
                </div>
            </div>
            {filters && (
                <div className="mx-auto max-w-[1600px] mb-4">
                    {filters}
                </div>
            )}
            <div
                ref={ref}
                data-testid={`${testId}-track`}
                className="scrollbar-hide overflow-x-auto flex gap-4 px-6 lg:px-10 pb-4 snap-x snap-mandatory"
            >
                {children}
            </div>
        </section>
    );
}
